
import { defineComponent } from "vue";

export default defineComponent({
  name: "SkinProfileRow",

  props: {
    icon: {
      type: String,
      required: true
    },

    iconType: {
      type: String,
      required: false,
      default: "fas"
    },

    iconColor: {
      type: String,
      required: false,
      default: "#000"
    },

    title: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: true
    }
  }
});
